import { POST } from '@wellsfargo/ecpfs-authority'

export const ATTORNEY_PRIVACY_POLICY_PATH = 'login/footer/eau/pp/tocText.json'

export function fetchAttorneyPrivacyPolicy() {
	return POST(ATTORNEY_PRIVACY_POLICY_PATH, {})
}
